// import React from "react";
// import Header from "./Header";
// import Sidebar from "./Sidebar";
// import { Outlet } from "react-router-dom";

// const MainLayout = () => {
//   return (
//     <div>
//       <Header />
//       <div className="flex-grow-1">
//         <div className="page-sidebar-left">
//           <Sidebar />
//         </div>
//         <div className="content">
//           <Outlet />
//         </div>
//         {/* Footer */}
//         {/* <Footer /> */}
//       </div>
//     </div>
//   );
// };

// export default MainLayout;


import FooterScript from "./FooterScript";
import React, { useEffect, useState } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import { Outlet } from "react-router-dom";
// import Chat from "./chat";
import { initializePermissions } from "../helpers/permission";
import {
  isNotificationSupported,
  requestAndSaveFcmToken,
} from "../helpers/firebaseNotification";
import { useEmailSocket } from "../email/socket/useEmailSocket";

const MainLayout = () => {
  // Listen for real-time email socket notifications globally across CRM
  useEmailSocket();

  // Get user data from localStorage/session (or context)
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const userId = user?.id;
  const userType = user?.user_type;
  const [, setPermissionsVersion] = useState(0);

  useEffect(() => {
    // Automatically trigger native Chrome notification permission prompt
    if (isNotificationSupported() && Notification.permission === "default") {
      requestAndSaveFcmToken();
    }
  }, []);

  useEffect(() => {
    // Force-refresh permissions on layout mount (covers page refresh)
    (async () => {
      try {
        await initializePermissions(true);
      } catch (e) {
        console.error("initializePermissions failed in MainLayout:", e);
      }
    })();

    // Listen for the permissionsUpdated event dispatched by initializePermissions
    const onPermUpdate = () => setPermissionsVersion((v) => v + 1);
    window.addEventListener("permissionsUpdated", onPermUpdate);

    return () => {
      window.removeEventListener("permissionsUpdated", onPermUpdate);
    };
  }, []);

  return (
    <div>
      <Header imageUrl={user?.profile_picture} />
      <div className="flex-grow-1">
        <div className="page-sidebar-left">
          <Sidebar />
        </div>
        <div className="content">
          <Outlet />
        </div>
        {/* <Chat /> */}
        {/* === React FooterScript (socket) === */}
        <FooterScript
          userId={userId}
          userType={userType}
          // notifySocketUrl="http://localhost:8086"
          notifySocketUrl={process.env.REACT_APP_NOTIFY_SOCKET_URL}
          subsEditLink={process.env.REACT_APP_BASE_URL + "Subscriber/edit/"}
        />
      </div>
    </div>
  );
};

export default MainLayout;